import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, Subject } from 'rxjs';

import { Letter } from "../../letters/letters.model";
import { SignedReportModel } from '../../common/models/signature.model';
import { IReportContextValue, ReportTemplate } from '../../models/comodel/mergefieldsmodel.model';
import { ChiefsOrderInstance } from '../../models/comodel/chiefsorderdetailsmodel.model';
import { GenerateReportModel } from '../../reports/model/reports.model';

@Injectable()
export class ReportSelectorService {

    constructor(public http: HttpClient) { }

    public static readonly BASE_URL = '/api/reports';

    generate(generateReportModel: GenerateReportModel): Observable<any> {
        return this.http.post(`${ReportSelectorService.BASE_URL}/generate`, generateReportModel, { responseType: 'blob' as 'blob' });
    }

    getCurrReqSignersList(reportTemplateId: string): Observable<string[]> {
        return this.http.get<string[]>(`${ReportSelectorService.BASE_URL}/getsignerslist/${reportTemplateId}`);
    }

    generateLetter(letter: Letter): Observable<any> {
        return this.http.post(`${ReportSelectorService.BASE_URL}/generateLetter`, letter, { responseType: 'blob' as 'blob' });
    }

    getMergeFields(reportTemplateId: string): Observable<IReportContextValue[]> {
        return this.http.get<IReportContextValue[]>(`api/reports/gettemplate/${reportTemplateId}`);
    }

    getTemplate(id: string): Observable<ReportTemplate> {
        return this.http.get<ReportTemplate>(`${ReportSelectorService.BASE_URL}/getTemplate/${id}`);
    }

    getTemplates(typeCode: string): Observable<Array<ReportTemplate>> {
        return this.http.get<Array<ReportTemplate>>(`${ReportSelectorService.BASE_URL}/templates/${typeCode}`);
    }

    getAllTemplates(): Observable<Array<ReportTemplate>> {
        return this.http.get<Array<ReportTemplate>>(`${ReportSelectorService.BASE_URL}/templates`);
    }

    saveTemplate(template: ReportTemplate): Observable<ReportTemplate> {
        return this.http.post<ReportTemplate>(`${ReportSelectorService.BASE_URL}/template/`, template);
    }

    signReport(model: SignedReportModel): Observable<ChiefsOrderInstance> {
        return this.http.post<ChiefsOrderInstance>(`${ReportSelectorService.BASE_URL}/sign`, model);
    }
}
